import { Box, ITheme, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface IFundDetailsTabsButtonProps{
    name: string;
    isSelected?: boolean;
    onClick: () => void;
}
const FundDetailsTabsButton: React.FC<IFundDetailsTabsButtonProps> = ({ name, isSelected, onClick}) => {
    const theme = useTheme() as ITheme;

    return <Box display={"flex"} flexBasis={"100px"} height={"48px"} flexGrow={1} borderRadius={"8px"} justifyContent={"center"} alignItems={"center"}
            bgcolor={isSelected ? theme.palette.primary.dark : theme.palette.common.white} 
            onClick={onClick} sx={{ cursor: "pointer" }}>
        <Typography fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"700"} textTransform={"uppercase"} color={isSelected ? theme.palette.common.white : theme.palette.common.black}>{name}</Typography>
    </Box>;
}

export default FundDetailsTabsButton;